import { createFileRoute } from "@tanstack/react-router";
import { PackagingTab } from "@/pages/PackagingTab";

export const Route = createFileRoute("/_authenticated/packaging")({
  head: () => ({
    meta: [
      { title: "Packaging · Oxley" },
      { name: "description", content: "Your current packages." },
      { property: "og:title", content: "Packaging · Oxley" },
      { property: "og:description", content: "Your current packages." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PackagingTab,
});
